/* global google */

import React from 'react';
import Address from '../address';

class ProductPageAddress extends Address {
  componentDidMount() {
    const id = this.props.customId || this.inputEle;
    this.autocomplete = new google.maps.places
      .Autocomplete(document.getElementById(id), { types: ['geocode'] });
    this.geolocate();
    this.geocoder = new google.maps.Geocoder();
  }

  geolocate() {
    /* noop */
  }

  render() {
    const id = this.props.customId || this.inputEle;
    return (
      <form className="inline-form" onSubmit={this.handleSubmit}>
        <label htmlFor="address-input" className="inline-form__subhead">
          Enter your address or ZIP code to check this product{"'"}s
          availability.
        </label>
        <div className="inline-form__input-container">
          <input
            type="text"
            id={id}
            className="form-control inline-form__input"
            placeholder="Address or ZIP"
            ref={this.inputRef}
          />
        </div>
        <div className="inline-form__button-container">
          <button type="submit" className="inline-form__button btn-primary">
            Submit
          </button>
        </div>
      </form>
    );
  }
}

export default ProductPageAddress;



// WEBPACK FOOTER //
// ./shared/components/availability/address.js